<template>
    <div class="main">
        <router-link to="/backorders" style="font-size:14px;text-decoration:none;line-height:30px;color:#98c14b;display:flex">
            <p>
                <a-icon type="double-left" />
            </p> 
            <p>Go Back</p>
            
        </router-link >
        <div>
            <h3 style="font-size:28px;line-height:45px"> Aggregate Backorders </h3>
        </div>
        <div style="display:flex;justify-content: flex-end;margin-bottom: 20px;">
            <a-button @click="generateOrders" :loading="loading" :disabled="!hasSelected" :class="[ hasSelected ? 'activeBtn' : 'disbablesBtn' ]">
                Generate Purchase Orders
            </a-button>
            <!-- <a-button @click="exportExcell" style="height:38px;border-raduis:5px; background: #418a49; color:#fff;" icon="export">
                Export
            </a-button> -->
        </div>
        
        <div>
                <a-table
                :columns="columns"
                :data-source="tableReplenishProducts"
                :loading='tableLoading'
                :pagination="pagination"
                class="customerTable"
                >
                    <template slot="action" slot-scope="data">    
                        <a-dropdown>
                            <a style="color:#98c14b;" class="ant-dropdown-link" @click="e => e.preventDefault()">
                                <a-icon style="font-size:25px;" type="ellipsis" />
                            </a>
                            <a-menu slot="overlay">
                                <a-menu-item >
                                    <a @click="replenishProduct(data)">Replenish Product?</a>
                                </a-menu-item>
                                
                            </a-menu>
                        </a-dropdown>
                    </template>

                    <template slot="status" slot-scope="data">
                        <status-component v-if="data" :status="data"></status-component>
                    </template>
                </a-table>
          </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
const columns = [
{
    title: "Product ID",
    width: 90,
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: 'Product Name',
    dataIndex: 'name',
    width: 100,
  },
  {
    title: 'Quantity Requested',
    dataIndex: 'quantity',
    width: 100,
  },
  {
    title: 'Supplier',
    dataIndex: 'supplierName',
    width: 100,
  },
//   {
//     title: 'Created At',
//     dataIndex: 'createdAt',
//     // width: 130,
//   },
 
//   {
//     title: 'Status',
//     dataIndex: 'status',
//     // width: 150,
//     scopedSlots: { customRender: 'status' }
//   },
 
//   {
//     title: 'Action',
//     dataIndex: 'action',
//     width: 100,
//     scopedSlots: { customRender: 'action' }
//   }
];

const tableReplenishProducts = [
    {
        id: 1,
        key: 1,
        name: 'Bruno Vaccines',
        quantity: 13,
        supplierName: "Tribeco",
        action: {}
    },
    {
        id: 2,
        key: 2,
        name: 'VTP Vaccines',
        quantity: 56,
        supplierName: "Tribeco",
        action: {}
    },
    {
        id: 3,
        key: 3,
        name: 'COVID Vaccines',
        quantity: 78,
        supplierName: "Tribeco",
        action: {}
    },
    {
        id: 4,
        key: 4,
        name: 'COVID Vaccines',
        quantity: 78,
        supplierName: "Tribeco",
        action: {}
    },
    {
        id: 5,
        key: 5,
        name: 'COVID Vaccines',
        quantity: 78,
         supplierName: "Tribeco",
        action: {}
    },{
        id: 6,
        key: 6,
        name: 'COVID Vaccines',
        quantity: 78,
         supplierName: "Tribeco",
        action: {}
    }
    ,{
        id: 7,
        key: 7,
        name: 'COVID Vaccines',
        quantity: 78,
        supplierName: "Tribeco",
        action: {}
    }
    ,{
        id: 8,
        key: 8,
        name: 'COVID Vaccines',
        quantity: 78,
        supplierName: "Tribeco",
        action: {}
    },
    {
        id: 9,
        key: 9,
        name: 'COVID Vaccines',
        quantity: 78,
        supplierName: "Tribeco",
        action: {}
    },
    {
        id: 10,
        key: 10,
        name: 'COVID Vaccines',
        quantity: 78,
        supplierName: "Tribeco",
        action: {}
    }

]
    export default {
        name: 'AggregatesOrder',
        data(){
            return {
                columns,
                tableReplenishProducts,
                tableLoading: false,
                loading: false,
                pagination: {
                    pageSize:5
                },
                selectedRowKeys: [],
                selectedRows: []
            }
        },
        computed:{
            hasSelected() {
                return this.tableReplenishProducts.length > 0;
            },
            rowSelection() {
                const { selectedRowKeys } = this;
                return {
                    selectedRowKeys,
                    onChange: this.onSelectChange,
                    hideDefaultSelections: true,
                    selections: [
                        {
                            key: 'all-data',
                            text: 'Select All Produts',
                            onSelect: () => {
                                this.selectedRowKeys = [...Array(tableReplenishProducts.length+1).keys()]; 
                                this.selectedRows = [...Array(tableReplenishProducts).values()]
                            },
                        },
                        {
                            key: 'unselect-data',
                            text: 'Deselect All Produts',
                            onSelect: () => {
                                this.selectedRowKeys = []; 
                                this.selectedRows = []
                            },
                        },
                    ],
                }
            },
            
        },
        methods:{
            ...mapActions(['setPreviewInfo']),
            replenishProduct(data){
                console.log("data | ", data)
            },
            onSelectChange(selectedRowKeys, selectedRows) {
                // console.log('selectedRowKeys changed: ', selectedRowKeys);
                // console.log('selectedRows changed: ', selectedRows);
                this.selectedRows = selectedRows
                this.selectedRowKeys = selectedRowKeys;
            },
            generateOrders(){
                // console.log('selectedRows: ', this.selectedRows);
                // console.log('selectedRowKeys: ', this.selectedRowKeys);
                // this.loading = true;
                // // ajax request after empty completing
                // setTimeout(() => {
                //     this.loading = false;
                //     this.selectedRowKeys = [];
                //     this.selectedRows = []
                // }, 1000);

                let tableData = this.tableReplenishProducts.map(product => ({
                    key:product.id,
                    id: product.id,
                    name: product.name ? product.name : "N/A",
                    category: product.categoryName ? product.categoryName : "Vaacines",
                    quantity: product.quantity ? product.quantity.toString() : '0',
                    unitPrice: product.purchasePrice ? product.purchasePrice.toString() : "123",
                    lineTotal: parseInt(product.quantity) * 123
                
                }))
                //TO-DO: Get supplier object here
                let previewData = { 
                    discount: '',
                    deliveryDate: '',
                    supplierName: "Tribeco",
                    supplierId: 1440,
                    supplierAddress: "Spintex",
                    supplierCity: '',
                    supplierCountry: '',
                    destionation: '',
                    sellerAddress: '',
                    shipCity: '',
                    shipCountry:'',
                    shippingMethod: '',
                    shippinTerm: '',
                    tableData: tableData,
                    statusLabel: '',
                    action:"add",
                    deleiveries:[]
                }
                // console.log("previewData | ", previewData)
                this.setPreviewInfo(JSON.stringify(previewData));  
                this.$router.push('/purchase-order-edit').catch(()=>{});
            }
            
        } 
    }
</script>

<style scoped>
.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}
.customerTable >>> .ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.customerTable >>> .ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.customerTable >>> .ant-pagination-item-active a {
    color: #fff;
}
.customerTable >>> .ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}
.disbablesBtn{
    color: rgba(0,0,0,.25);
    background-color: #f5f5f5;
    border-color: #d9d9d9;
    text-shadow: none;
    box-shadow: none;
    height:38px;
     border-raduis:5px; 
}
.activeBtn{
    height:38px;
    margin-right: 10px;
    border-raduis:5px; 
    background: #418a49; 
    color:#fff;
}
</style>